import { GAP_OPERATIONS } from './gap-operations';

/** A user's level on GAP, as authz grants it and APIM requires it: each includes the ones before. */
export type GapLevel = 'read' | 'write' | 'admin';

const LADDER: readonly GapLevel[] = ['read', 'write', 'admin'];

type Operations = typeof GAP_OPERATIONS;

/** An operation of a GAP API, as APIM names it: `client:save`, `env:getAllV2`. */
export type GapOperation = { [Api in keyof Operations]: `${Api & string}:${keyof Operations[Api] & string}` }[keyof Operations];

/** The level APIM requires for this operation. */
export function requiredLevel(operation: GapOperation): GapLevel {
  const [api, name] = operation.split(':') as [keyof Operations, string];
  return (GAP_OPERATIONS[api] as Record<string, GapLevel>)[name] ?? 'admin';
}

/** Whether a user at this level may run this operation. */
export function allows(level: GapLevel, operation: GapOperation): boolean {
  return LADDER.indexOf(level) >= LADDER.indexOf(requiredLevel(operation));
}

/** authz's `READER`, `WRITER` or `ADMIN` as a GAP level; null for anything else. */
export function toGapLevel(accessLevel: string | null | undefined): GapLevel | null {
  switch (accessLevel?.toUpperCase()) {
    case 'READER':
      return 'read';
    case 'WRITER':
      return 'write';
    case 'ADMIN':
      return 'admin';
    default:
      return null;
  }
}
